import {
  createStore,
  combineReducers,
  compose,
  applyMiddleware,
  Action
} from "redux";
import {
  reactReduxFirebase,
  firebaseReducer,
  getFirebase
} from "react-redux-firebase";
import authReducer from "./store/reducers/authReducer";
import thunk from "redux-thunk";
import {
  reduxFirestore,
  getFirestore,
  firestoreReducer
} from "redux-firestore";
import firebase from 'firebase/app';
import myConfig from "./firebase/config.json";
//import {ReduxState} from './redux2';
import regReducer from "./store/reducers/regReducers";
import supportReducer from "./store/reducers/supportReducer";
import deleteReducer from "./store/reducers/deleteReducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import searchProfileReducer from "./store/reducers/searchReducer";
import cookieReducer from "./store/reducers/cookieReducer";
// import {Store} from 'redux';

/*const fbConfig = {
    apiKey: "AIzaSyBQZTsl3DNU5oQSB4IccgMIv7lsYCNoPZw",
    authDomain: "smokeless-world-develop.firebaseapp.com",
    databaseURL: "https://smokeless-world-develop.firebaseio.com",
    messagingSenderId: "2062546517",
    projectId: "smokeless-world-develop",
    storageBucket: "smokeless-world-develop.appspot.com"
  };
*/
const fbConfig = myConfig;

const rrfConfig = {
  userProfile: "users",
  useFirestoreForProfile: true
};

firebase.initializeApp(fbConfig);
firebase.analytics();
// var db = firebase.firestore();

const appReducer = combineReducers({
  firebase: firebaseReducer,
  auth: authReducer,
  firestore: firestoreReducer,
  reg: regReducer,
  sup: supportReducer,
  del: deleteReducer,
  search: searchProfileReducer,
  cookies: cookieReducer
});

const persistConfig = {
  key: "root",
  storage
};

const persistedReducer = persistReducer(persistConfig, appReducer);

/*function rootReducer(state: ReduxState | undefined, action: Action){
    return appReducer(state,action);
}*/

// const initialState = {};

const store = createStore(
  persistedReducer,
  compose(
    applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore })),
    reactReduxFirebase(firebase, rrfConfig), // redux binding for firebase
    // @ts-ignore
    reduxFirestore(firebase) // redux bindings for firestore
  )
);

const persistor = persistStore(store);

/*const rrfProps = {
    firebase,
    config: rrfConfig,
    dispatch: store.dispatch
 }*/

export { store, persistor /*,rrfProps*/ };



// WEBPACK FOOTER //
// ./src/reduxstore.tsx